module.exports = __webpack_public_path__ + "school/fonts/HYQuanTangShiJ.456d7887.eot";